module.exports = __webpack_public_path__ + "static/media/operations-feature-tile-icon-03.fc4fe82b.svg";